<template>
  <div id="uyh-img-upload">
    <div class="upload-container">
      <svg svg-inline="" class="close" @click="$emit('hide-gallery-upload')" role="presentation" focusable="false" width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle cx="15" cy="15" r="15"/><path d="M8.726 21.72a.795.795 0 0 0 1.143 0l5.09-5.089 5.089 5.09a.816.816 0 0 0 1.143.086c.345-.28.366-.798.086-1.143-.022-.022-.043-.065-.086-.086l-5.09-5.089 5.089-5.09a.814.814 0 0 0 .043-1.142.814.814 0 0 0-1.143-.043l-.043.043-5.088 5.09-5.09-5.09a.815.815 0 0 0-1.143.044.824.824 0 0 0 0 1.1l5.09 5.088-5.09 5.09a.834.834 0 0 0 0 1.142z" fill="#000"/></g></svg>
      <p class="cta-text">{{ $t('get_image.choose_image') }}</p>
      <div class="image-upload-area" id="drag-and-drop" v-if="windowWidth > 1023">
        <span class="removeImage"><svg svg-inline="" @click="clearImage" role="presentation" focusable="false" width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle cx="15" cy="15" r="15"/><path d="M8.726 21.72a.795.795 0 0 0 1.143 0l5.09-5.089 5.089 5.09a.816.816 0 0 0 1.143.086c.345-.28.366-.798.086-1.143-.022-.022-.043-.065-.086-.086l-5.09-5.089 5.089-5.09a.814.814 0 0 0 .043-1.142.814.814 0 0 0-1.143-.043l-.043.043-5.088 5.09-5.09-5.09a.815.815 0 0 0-1.143.044.824.824 0 0 0 0 1.1l5.09 5.088-5.09 5.09a.834.834 0 0 0 0 1.142z" fill="#000"/></g></svg></span>
        <div class="image-message-wrapper">
          <input type="file" v-on:change="imgUploader" class="hidden-input" id="image-input" accept=".jpg,.jpeg,.png">
          <img src="#" id="img-uploaded">
          <div class="message">
            <svg svg-inline="" role="presentation" focusable="false" width="94" height="114" viewBox="0 0 94 114" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g stroke="#FCEFF3" stroke-width="3"><rect x="1.5" y="1.5" width="61.103" height="73.923" rx="3"/><rect fill="#223628" x="22.013" y="24.577" width="61.103" height="73.923" rx="3"/></g><g transform="translate(62 82)"><circle fill="#FC7CA0" cx="16" cy="16" r="16"/><path d="M8.375 15.875h14.512M15.875 8.375v14.512" stroke="#223628" stroke-width="2" stroke-linecap="square"/></g></g></svg>
            <p>{{ $t('get_image.drop_photo') }}</p>
            <p>{{ $t('get_image.or') }}</p>
            <p class="browse" @click="browseFiles"><a @click.prevent href="">{{ $t('get_image.browse') }}</a></p>
          </div>
        </div>
      </div>

      <div class="image-upload-area" id="drag-and-drop" v-else-if="windowWidth < 1024" @click="browseFiles">
        <span class="removeImage"><svg svg-inline="" @click="clearImage" role="presentation" focusable="false" width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle cx="15" cy="15" r="15"/><path d="M8.726 21.72a.795.795 0 0 0 1.143 0l5.09-5.089 5.089 5.09a.816.816 0 0 0 1.143.086c.345-.28.366-.798.086-1.143-.022-.022-.043-.065-.086-.086l-5.09-5.089 5.089-5.09a.814.814 0 0 0 .043-1.142.814.814 0 0 0-1.143-.043l-.043.043-5.088 5.09-5.09-5.09a.815.815 0 0 0-1.143.044.824.824 0 0 0 0 1.1l5.09 5.088-5.09 5.09a.834.834 0 0 0 0 1.142z" fill="#000"/></g></svg></span>
        <div class="image-message-wrapper">
          <input type="file" v-on:change="imgUploader" class="hidden-input" id="image-input" accept=".jpg,.jpeg,.png">
          <img src="#" id="img-uploaded">
          <div class="message">
            <svg svg-inline="" role="presentation" focusable="false" width="94" height="114" viewBox="0 0 94 114" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g stroke="#FCEFF3" stroke-width="3"><rect x="1.5" y="1.5" width="61.103" height="73.923" rx="3"/><rect fill="#223628" x="22.013" y="24.577" width="61.103" height="73.923" rx="3"/></g><g transform="translate(62 82)"><circle fill="#FC7CA0" cx="16" cy="16" r="16"/><path d="M8.375 15.875h14.512M15.875 8.375v14.512" stroke="#223628" stroke-width="2" stroke-linecap="square"/></g></g></svg>
            <p>{{ $t('get_image.moible_image_cta') }}</p>
          </div>
        </div>
      </div>

      <button class="uyh-btn secondary disabled" id="upload" @click="editMantra">{{ $t('navigation.next') }}</button>
    </div>
  </div>
</template>

<script>
  // import Cropper from 'cropperjs'
  import EXIF from 'exif-js'
  var file = '';

  export default {
    name: 'imageUpload',
    data: function() {
      return {
        windowWidth: 0
      }
    },
    beforeMount: function () {
      this.$store.dispatch('updateShare', false);
      this.$store.dispatch('updateMantrapage', true);
    },
    methods: {
      widowWidth: function() {
        var $this = this;
        $this.windowWidth = window.innerWidth;
      },
      displayImage: function(file) {
        var reader = new FileReader();
        var removeImage = document.querySelector('.removeImage');
        removeImage.classList.add('visible');
        var $this = this;
        reader.onload = function (e) {
          var image = document.getElementById('img-uploaded');

          var img = new Image();
          img.onload = function(e) {
            e.preventDefault();
            EXIF.getData(img, function(){
              var height = '';
              var width = ''
              var ctx = ''
              var allMetaData = EXIF.getAllTags(this);
              var orientation = allMetaData.Orientation;
              if (orientation && (4 < orientation && orientation < 9)) {
                width = this.naturalHeight;
                height = this.naturalWidth;
              } else {
                width = this.naturalWidth;
                height = this.naturalHeight;
              }

              var deleteCanvas = document.getElementById('hidden-canvas');
              if (deleteCanvas) {
                deleteCanvas.parentNode.removeChild(deleteCanvas);
              }

              var canvas = document.createElement('canvas');
              canvas.style.display = 'none';
              canvas.id = 'hidden-canvas';
              canvas.width = width;
              canvas.height = height;

              if (orientation) {
                // Orientation implies mobile
                ctx = $this.setOrientation(canvas, orientation, width, height);
                var rotationOffset = height - width;
                if (orientation == 8 || orientation == 7) {
                  rotationOffset = 0;
                }
                ctx.drawImage(this, 0, rotationOffset, height, width);
                image.src = canvas.toDataURL('image/jpeg');
              } else {
                // Undefined orientation implies desktop
                // Desktop requires different draw (no rotation applied)
                ctx = canvas.getContext('2d');
                ctx.drawImage(this, 0, 0, width, height);
                image.src = canvas.toDataURL('image/jpeg');
              }

              image.classList.add('visible');
              document.getElementById('upload').classList.remove('disabled');
              document.body.appendChild(canvas);
            });
          }
          img.src = e.target.result;

        };

        reader.readAsDataURL(file);
      },

      setOrientation: function(canvas, orientation, width, height) {
        var ctx = canvas.getContext('2d');
        switch (orientation) {
          case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
          case 3: ctx.transform(-1, 0, 0, -1, width, height); break;
          case 4: ctx.transform(1, 0, 0, -1, 0, height); break;
          case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
          case 6: ctx.transform(0, 1, -1, 0, height, 0); break;
          case 7: ctx.transform(0, -1, -1, 0, width, height); break;
          case 8: ctx.transform(0, -1, 1, 0, 0, height); break;
        }
        return ctx;
      },

      imgUploader: function(e) {
        var $this = this;
        var input = e.target;
        if (input.files && input.files[0]) {
          file = input.files[0];
          $this.displayImage(file);
        }
      },
      browseFiles: function() {
        document.getElementById('image-input').click();
      },
      clearImage: function() {
        var imageUploaded = document.getElementById('img-uploaded');
        var imageInput = document.getElementById('image-input');
        var removeImage = document.querySelector('.removeImage');
        var button = document.querySelector('#upload');

        button.classList.add('disabled');
        removeImage.classList.remove('visible');
        imageUploaded.classList.remove('visible');
        imageUploaded.src="";
        imageInput.value = "";
      },
      dragAndDrop: function() {
        var $this = this;
        var dropArea = document.getElementById('drag-and-drop');

        // Prevent default events so that image doesn't open in browser
        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
          dropArea.addEventListener(eventName, function(e){
            e.preventDefault();
            e.stopPropagation();
          }, false);
        });

        dropArea.addEventListener('drop', function(e){
          var dataTransfer = e.dataTransfer;
          file = dataTransfer.files[0];
          if (file.type == 'image/png' || file.type == 'image/jpeg' || file.type == 'image/jpg') {
            $this.displayImage(file);
          } else {
            alert('Only JPEG and PNG images are allowed.');
          }
        }, false);
      },
      editMantra:function() {
        this.$emit('hide-gallery-upload');
        var activeSlide = document.querySelector('.slick-current');
        var link = '/send-message/' + activeSlide.querySelector('.uyh-background.primary').dataset.template + '/image';
        if (link.includes('#')) {
          link = link.split('#')[1];
        }
        this.$router.push(link);
      }
    },
    mounted: function() {
      this.$nextTick(function(){
        this.dragAndDrop();
        window.addEventListener('resize', this.widowWidth);
        this.widowWidth();
        document.getElementById('uyh-app').classList.add('frozen');
      });
    },
    destroyed: function() {
      document.getElementById('uyh-app').classList.remove('frozen');
    }
  }
</script>

<style lang="scss" scoped>
  .responsivesite #wrapper #uyh-app,
  #uyh-app {
    $mobile-breakpoint: 767px;
    $tablet-portrait-down-breakpoint: 1023px;
    $tablet-down-breakpoint: 1199px;
    $tablet-breakpoint: 1200px;
    $hd-desktop-breakpoint: 1280px;

    #uyh-img-upload {
      background-color: rgba(0,0,0,0.75);
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100vw;
      z-index: 19;

      .upload-container {
        background-color: #223628;
        left: 50%;
        max-height: 100vh;
        max-width: 100%;
        min-height: calc(100% - 70px);
        padding: 36px 0;
        position: absolute;
        text-align: center;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 1000px;

        .close {
          cursor: pointer;
          position: absolute;
          right: 27px;
          top: 13px;
          path {
            fill: #fceff3;
          }
        }

        .cta-text {
          color: #fceff3;
          display: block;
          font-size: 25px;
          margin: 0 auto;
        }

        .image-upload-area {
          border: 1px dashed #fceff3;
          display: block;
          margin: 40px auto;
          position: relative;
          width: calc(2 / 5 * 100%);
          &:before {
            content: '';
            display: block;
            padding-top: calc(3 / 2 * 100%);
          }

          .removeImage {
            background-color: #fceff3;
            border-radius: 100%;
            display: block;
            height: 30px;
            position: absolute;
            right: -15px;
            top: -15px;
            visibility: hidden;
            width: 30px;
            z-index: 1;
            &.visible {
              cursor: pointer;
              visibility: visible;
            }
            path {
              fill: #fc7ca0;
            }
          }

          .image-message-wrapper {
            height: 100%;
            left: 0;
            overflow: hidden;
            position: absolute;
            top: 0;
            transition: none;
            width: 100%;
            z-index: 0;
          }

          .hidden-input {
            position: absolute;
            visibility: hidden;
            z-index: -1;
          }

          #img-uploaded {
            display: none;
            height: 100%;
            left: 50%;
            position: absolute;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
            z-index: 1;
            &.visible {
              display: block;
            }
          }

          .message {
            left: 50%;
            position: absolute;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
            svg {
              margin-bottom: 16px;
              width: 94px;
            }
            p {
              color: #fceff3;
              line-height: 1.65;
              &.browse {
                cursor: pointer;
                display: inline-block;
                a {
                  color: #fceff3;
                  display: block;
                  &::after {
                    display: none;
                  }
                }
                &:after {
                  background-color: #fceff3;
                  content: '';
                  display: block;
                  height: 2px;
                  position: relative;
                  transition: background-color 0.3s ease-in-out;
                  width: 100%;
                }

                &:hover {
                  color: #fc7ca0;
                  &:after {
                    background-color: #fc7ca0;
                  }
                }
              }
            }
          }
        }

        .uyh-btn {
          display: block;
          margin: 0 auto;
          &.disabled {
            cursor: default;
            opacity: 0.6;
            pointer-events: none;
            &:hover {
              background-color: transparent;
              border: 1px solid #fceff3;
              color: #fceff3;
            }
          }
        }
      }
      @media screen and (min-width: $tablet-breakpoint) and (max-width: $hd-desktop-breakpoint) {
        .upload-container {
          padding: 24px 0;
          .image-upload-area {
            margin: 24px auto;
            width: calc((2 / 5 * 100%) - 115px);
          }
        }
      }

      @media screen and (max-width: $tablet-portrait-down-breakpoint) {
        height: 100vh;
        position: fixed;
        overflow-x: hidden;
        overflow-y: auto;

        .upload-container {
          left: initial;
          max-height: none;
          min-height: calc(100% + 90px);
          position: relative;
          top: initial;
          transform: none;
          width: 100%;
          .close {
            right: 17px;
          }
          .cta-text {
            font-size: 20px;
            margin-top: 0;
          }
          .image-upload-area {
            margin: 18px auto;
            max-width: 400px;
            width: calc(100% - 76px);
          }
        }
      }
      @media screen and (max-width: $mobile-breakpoint) {
        .upload-container {
          .cta-text {
            margin-top: 18px;
          }
        }
      }
    }
  }
</style>
